// eslint-disable-next-line import/prefer-default-export
export enum TextAlignment {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right'
}
